import React from 'react';
import InicioContainer from '../containers/InicioContainer';

export default function RouteInicio({ history }){
    return <InicioContainer history={history} />;
}